import { useContext } from 'react';
import { UserContext } from '../context/userContext';

export default function Home() {
  const { userDetail } = useContext(UserContext);

  return (
    <div className="welcome-note flex items-end flex-col text-right mb-12 lg:mb-0">
      <h1 className="text-3xl lg:text-4xl font-bold">
        <span className="block lg:inline text-primary-blue-500">
          welcome home, &nbsp;
        </span>
        <span className="text-secondary-pink-500">
          {userDetail.preferred_name ?? userDetail.first_name}
        </span>
      </h1>
      <p className="text-xl lg:text-2xl text-primary-blue-500 font-regular mt-2 lg:mt-0">
        we’re happy you found your way home.{' '}
      </p>
    </div>
  );
}
